import { supabase } from './supabase';

export function logoutAndReturnHome(): void {
  const projectRef = new URL(import.meta.env.VITE_PUBLIC_SUPABASE_URL).hostname.split('.')[0];
  const storageKey = `sb-${projectRef}-auth-token`;

  // Clear the browser session first so a slow auth request can never trap the
  // user on an authenticated or access-denied screen.
  window.localStorage.removeItem(storageKey);
  window.localStorage.removeItem(`${storageKey}-code-verifier`);

  void supabase.auth.signOut({ scope: 'local' }).catch(() => undefined);
  window.location.replace('/?logged_out=1');
}
